import React, { useRef, useState } from "react";
import Learn from "./../../assets/images/learn.png";
// import Art from "./../../assets/images/art_video.png";
import {BsFillPlayFill,BsPauseFill} from "react-icons/bs"
import "./art.css";
const Art = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const [progress, setProgress] = useState(0);

  const handlePlayPause = () => {
    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  const handleTimeUpdate = () => {
    const { currentTime, duration } = videoRef.current;
    const progressPercentage = (currentTime / duration) * 100;
    setProgress(progressPercentage);
  };

  const handleSeek = (e) => {
    const { duration } = videoRef.current;
    const clickPosition = e.nativeEvent.offsetX;
    const progressBarWidth = e.target.clientWidth;
    const seekTime = (clickPosition / progressBarWidth) * duration;
    videoRef.current.currentTime = seekTime;
  };

 
  return (
    <div className="art" id="discover">
      <div className="art_inner">
        <div className="art_left">
          <p className="art_heading">
            The art of using beauty sponge with finesse
          </p>
          <p className="art_content">
            Get ready to rock your beauty game! Follow our step-by-step guide to
            using MIXY Beauty Sponge and unveil a whole new level of confidence
            and allure.
          </p>
          <img src={Learn} alt="" className="art_learn" />
        </div>
        <div className="art_right">
          {/* <img src={Art} alt="" /> */}
          <div className="video-player">
            <video
              ref={videoRef}
              autoPlay
              src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
              onTimeUpdate={handleTimeUpdate}
              style={{ width: "100%" }}
            />

            <div className="controls">
              <button onClick={handlePlayPause} className="control_btn">
                {isPlaying ? <BsPauseFill /> : <BsFillPlayFill />}
              </button>
              <div className="progress-bar" onClick={handleSeek} style={{ flex:1}}>
                <div className="progress" style={{ width: `${progress}%` }} />
              </div>
              <div style={{width:'5px'}} />
             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Art;
